import { IconSvgElement } from "@hugeicons/react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { useInboxBadge } from "views/inbox/api/use-inbox-badge";
import { formatNavBadgeCount } from "../use-nav-item-counts";
import { NavLink } from "./NavLink";

interface InboxNavLinkProps {
  name: string;
  to: string;
  Icon: IconSvgElement;
}

export const InboxNavLink = ({ name, to, Icon }: InboxNavLinkProps) => {
  const { badge } = useInboxBadge();
  const isWaiting = badge.total > 0;

  return (
    <Tooltip placement="bottom-start">
      <TooltipTrigger asChild>
        <span className="block">
          <NavLink
            to={to}
            HugeIcon={Icon}
            indicator={isWaiting ? formatNavBadgeCount(badge.total) : undefined}
          >
            {name}
          </NavLink>
        </span>
      </TooltipTrigger>
      <Show if={isWaiting}>
        <TooltipContent className="rounded-lg border p-3 text-sm text-white z-[51]">
          {badge.awaiting_reply} waiting on a reply · {badge.escalated}{" "}
          escalated
        </TooltipContent>
      </Show>
    </Tooltip>
  );
};
